import React, {
  Component,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import CartContext from "./CartContext.js";
import ProductCard from "./ProductCard.js";
import { OrderSummaryPOS } from "./OrderSummaryPOS.js";
import CheckoutPOS from "./CheckoutPOS.js";
import SearchViewPOS from "./SearchViewPOS.js";
import { Navigate } from "react-router-dom";
import ElasticCartAd from "./ElasticCartAd.js";
import { BsFillMicFill, BsFillMicMuteFill } from "react-icons/bs";
import ReactDOM from "react-dom";
import axios from "axios";
import "../CSS/3d.css";
import Swal from "sweetalert2";
import FavList from "./FavList.js";
import Select, { createFilter } from "react-select";
import { MenuList } from "./SearchViewPOS.js";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import BarcodeReader from "react-barcode-reader";
import IncDecCounter from "./IncDecCounterControl.js";
import { TableDashboard1 } from "./TableOrders.js";
import TableOrder from "./TableOrder.js";
import { MdDelete } from "react-icons/md";

import {
  Navbar,
  Nav,
  Button,
  InputGroup,
  Badge,
  ButtonGroup,
  ToggleButton,
  FloatingLabel,
  FormControl,
  Link,
  Table,
  Tooltip,
  OverlayTrigger,
  Modal,
  Form,
  Row,
  Col,
  Stack,
  Tab,
} from "react-bootstrap";
import {
  ControlledMenu,
  useHover,
  MenuItem,
  SubMenu,
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

const WAIT_INTERVAL = 500;

export default class CartViewPOS extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      forUpdateValue: 1,
      showAddCustomItemModal: false,
      showAddFromSaleOrderModal: false,
    };
  }

  forceUpdate = () => {
    this.setState({ forUpdateValue: 0 }, () => {
      this.setState({ forUpdateValue: 1 });
    });
  };

  isMainCategoryHasItems = (maincategory) => {
    var result = false;

    this.context
      .getPOSCartByName(this.context.selectedPOS)
      .filter((item) => item.prod.mainCategoryId === maincategory.id).length > 0
      ? (result = true)
      : (result = false);

    return result;
  };

  ValidateProductInstockAvailablity = () => {
    var cart = this.context.getPOSCartByName(this.context.selectedPOS);
    cart.map((p, i) => {
      var prd = this.context.prodsAll.filter((f) => f.id == p.prod.id);
      if (prd.length == 1 && prd[0].inStockQty >= Number(p.qty)) {
        //ok
        console.log("prod in-stock" + prd[0].name);
      } else {
        //delete prod from cart
        if (p.prod.id.includes("Custom") === false)
          this.context.deleteItemOnMyCart(p.prod.id);
      }
    });
  };

  ShowAddCustomItemModal = () => {
    this.setState({ showAddCustomItemModal: true });
  };
  HideAddCustomItemModal = () => {
    this.setState({ showAddCustomItemModal: false });
  };

  OnAddCustomItem = () => {
    this.ShowAddCustomItemModal();
  };

  CloseCartOffCanvas = () => {
    this.props.CloseCartOffCanvas();
  };

  _handleNVEvent = (event) => {
    if (event.key == undefined) return;
    if (event.key == "F4") {
      event.preventDefault();
      this.OnAddCustomItem();
    }
  };
  componentDidMount() {
    document.addEventListener("keydown", this._handleNVEvent, false);
    window.scrollTo(0, 0);
    //this is not required for POS
    //this.ValidateProductInstockAvailablity();
    this.context.UpdateOrderStatus("");

    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.keyCode == 17) {
        var ctrl = document.getElementById("carttable");
        if (ctrl) {
          ctrl.focus();
          // ctrl.select();
        }
      }
    });
  }

  handleInputChange = (e, i) => {
    const { name, value } = e.target;
    switch (name.trim()) {
      case "qty":
        this.state.carousels[i].imgFileName = value;
        break;
    }
  };
  GetProductNameDetailed = (prod) => {
    var result = prod.name;
    if (prod.hsncode) result += " HSNCode: " + prod.hsncode;
    if (prod.batchId) result += " BatchId: " + prod.batchId;
    if (prod.qualityId) result += " QualityId: " + prod.qualityId;
    return result;
  };
  OnAddFromSaleOrder = () => {
    // TODO: Open your Sale Order modal / redirect / API call here
    // Example placeholder:
    alert("Add from Sale Order clicked!");
  };

  OnQtyChange = (e, cartItem) => {
    const newQty = Number(e.target.value || 0);

    if (newQty !== Number(cartItem.qty)) {
      cartItem.qty = newQty;

      // Recalculate discount based on selling price rules
      let appliedDiscount = cartItem.prod.discount || 0;
      const prod = cartItem.prod;

      if (prod.sellingPriceBusinessRuleId && this.context.sellingPriceRules) {
        const rule = this.context.sellingPriceRules.find(
          (r) =>
            String(r.sellingPriceBusinessRuleId).toLowerCase() ===
            String(prod.sellingPriceBusinessRuleId).toLowerCase(),
        );

        if (rule) {
          const tiers = rule.sellingPriceRuleTiers || [];
          tiers.sort((a, b) => (a.seqNo ?? 0) - (b.seqNo ?? 0));

          const tier = tiers.find((t) => {
            const minOk =
              t.minQtyInclusive == null || newQty >= t.minQtyInclusive;
            const maxOk =
              t.maxQtyInclusive == null || newQty <= t.maxQtyInclusive;
            return minOk && maxOk;
          });

          if (tier) {
            appliedDiscount = tier.discountPercentOfMrp;
          }
        }
      }

      // Update the discount on the cart item
      cartItem.prod.discount = appliedDiscount;

      // Update cart state
      this.context.SetStateOfMyCart(
        this.context.getPOSCartByName(this.context.selectedPOS),
      );
      this.context.forceUpdateCartView();
    }
  };

  render() {
    if (this.context.storeId == "") return <Navigate to="/home" />;
    if (this.state.forUpdateValue == 0) return "";
    if (
      (this.context.userData != undefined &&
        this.context.userData.posRoleId == 1) ||
      this.context.userData.posRoleId == 2 ||
      this.context.userData.posRoleId == null ||
      this.context.userData.posRoleId == undefined
    ) {
    } else if (
      this.context.userData != undefined &&
      this.context.userData.posRoleId == 3
    ) {
      return <Navigate to="/TableOrders" />;
    }

    return (
      <>
        {this.state.showAddCustomItemModal == true ? (
          <AddCustomItem
            myClientIpAddress={this.props.myClientIpAddress}
            onHide={this.HideAddCustomItemModal}
          ></AddCustomItem>
        ) : (
          ""
        )}
        {this.state.showAddFromSaleOrderModal ? (
          <AddFromSaleOrderModal
            onHide={() => this.setState({ showAddFromSaleOrderModal: false })}
          />
        ) : null}

        {window.innerWidth > 900 ? (
          <>
            <div
              className="w-100 p-2 border-bottom bg-light d-flex justify-content-between align-items-center"
              style={{ backgroundColor: "white" }}
            >
              {/* Left: Title */}
              <h5 className="m-0 fw-bold text-dark">
                <i className="bi bi-cart-check-fill"></i>
                &nbsp; CHECKOUT
              </h5>

              {/* Right: Buttons (aligned right) */}
              <div className="d-flex align-items-center">
                <Button
                  onClick={this.OnAddCustomItem}
                  className="px-3 py-1 border-0 text-dark fw-bold me-2"
                  style={{ backgroundColor: "cyan" }}
                >
                  + Add Custom (F4)
                </Button>

                <Button
                  onClick={() =>
                    this.setState({ showAddFromSaleOrderModal: true })
                  }
                  className="px-3 py-1 border-0 text-dark fw-bold"
                  style={{ backgroundColor: "lightgreen" }}
                >
                  + Add from Sale Order
                </Button>
              </div>
            </div>

            <OrderType
              handleChangeOrderType={this.props.handleChangeOrderType}
            ></OrderType>
            <div
              className="w-100 m-0 p-0 border-0 "
              style={{
                backgroundColor: this.context.cartBackgroundColor,
                overflow: "scroll",
                minHeight: window.innerHeight - 0 + "px",
                maxHeight: window.innerHeight - 0 + "px",
              }}
            >
              <Table
                // border
                className="w-100 border-0 m-0 p-0 bg-dark text-white"
                responsive="md"
                // style={{ fontSize: "10pt" }}
              >
                <thead className="text-center m-0 p-0 ">
                  <tr
                    className="w-100 text-center m-0 p-0 verticalaligncentertd"
                    style={{
                      backgroundColor: "lightcyan",
                      color: "darkcyan",
                      fontSize: "10pt",
                    }}
                  >
                    <td
                      width="45%"
                      className="text-center verticalaligncentertd border-0 border-secondary"
                    ></td>

                    {window.location.hostname ==
                    "sharoffsteel-pos.elasticcart.com" ? (
                      <>
                        <td
                          width="10%"
                          className=" border-0 border-secondary text-start"
                        >
                          Pieces
                        </td>
                        <td
                          width="12%"
                          className=" border-0 border-secondary text-start"
                        >
                          Qty/Wt
                        </td>
                        <td
                          width="13%"
                          className=" border-0 border-secondary text-start"
                        >
                          Price
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          width="15%"
                          className=" border-0 border-secondary text-center"
                        >
                          Price
                        </td>
                        <td width="5%" className=" border-0 border-secondary">
                          Disc(%)
                        </td>
                        <td width="10%" className=" border-0 border-secondary">
                          Qty/Wt
                        </td>
                      </>
                    )}

                    <td width="15%" className="border-0 border-secondary">
                      Total
                    </td>
                    <td width="5%" className="border-0 border-secondary"></td>
                  </tr>
                </thead>
              </Table>
              <div className="w-100 m-0 p-0 " style={{ fontSize: "12px" }}>
                {/* Show Cart Items */}
                <div className="mb-5 ">
                  <Table borderless>
                    {this.context
                      .getPOSCartByName(this.context.selectedPOS)
                      .map((item) => item)
                      .reverse()
                      .map((cartitem, i) => (
                        <>
                          <div className="my-2 ">
                            <tr
                              className="w-100 text-start m-0 p-0 "
                              style={{
                                backgroundColor:
                                  this.context.productCardBackgroundColor,
                                color: this.context.productCardTextColor,
                              }}
                            >
                              <td
                                width={
                                  window.location.hostname ==
                                  "sharoffsteel-pos.elasticcart.com"
                                    ? "45%"
                                    : "45%"
                                }
                                className="text-start border-0 border-secondary"
                              >
                                {i + 1} &nbsp; &nbsp;&nbsp;{" "}
                                <strong className="">
                                  {/* {cartitem.prod.name} */}
                                  {this.GetProductNameDetailed(cartitem.prod)}
                                </strong>
                                {cartitem.prod.sku ? (
                                  <>
                                    <br />
                                    <span
                                      className="text-info"
                                      style={{ fontSize: "10px" }}
                                    >
                                      <small>
                                        &nbsp; SKU: {cartitem.prod.sku}
                                      </small>
                                    </span>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </td>

                              {/* SharoffSteel → Pieces, Qty, Price */}
                              {window.location.hostname ==
                              "sharoffsteel-pos.elasticcart.com" ? (
                                <>
                                  <td width="10%">
                                    <Form.Control
                                      size="lg"
                                      type="text"
                                      value={cartitem.pieceCount}
                                      className="text-center"
                                      onChange={(e) => {
                                        if (e.target.value > 0) {
                                          cartitem.pieceCount = e.target.value;
                                          this.context.SetStateOfMyCart(
                                            this.context.getPOSCartByName(
                                              this.context.selectedPOS,
                                            ),
                                          );
                                          this.context.forceUpdateCartView();
                                        }
                                      }}
                                    />
                                  </td>
                                  <td width="12%">
                                    <Form.Control
                                      type="text"
                                      size="lg"
                                      value={cartitem.qty}
                                      className="text-center"
                                      onChange={(e) => {
                                        if (e.target.value != cartitem.qty) {
                                          cartitem.qty = e.target.value;
                                          this.context.SetStateOfMyCart(
                                            this.context.getPOSCartByName(
                                              this.context.selectedPOS,
                                            ),
                                          );
                                          this.context.forceUpdateCartView();
                                        }
                                      }}
                                    />
                                  </td>
                                  <td width="15%">
                                    <Form.Control
                                      type="text"
                                      size="lg"
                                      value={cartitem.prod.mrp}
                                      className="text-center"
                                      onChange={(e) => {
                                        cartitem.prod.mrp = Number(
                                          e.target.value,
                                        );
                                        this.context.SetStateOfMyCart(
                                          this.context.getPOSCartByName(
                                            this.context.selectedPOS,
                                          ),
                                        );
                                        this.context.forceUpdateCartView();
                                      }}
                                    />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    width="15%"
                                    className="order text-center border-0 border-secondary"
                                  >
                                    {this.context.storeSettings
                                      .priceEditableOnCart == true ? (
                                      <>
                                        <Form.Control
                                          type="text"
                                          size="lg"
                                          value={cartitem.prod.mrp}
                                          className="text-center"
                                          onChange={(e) => {
                                            cartitem.prod.mrp = e.target.value;
                                            this.context.SetStateOfMyCart(
                                              this.context.getPOSCartByName(
                                                this.context.selectedPOS,
                                              ),
                                            );
                                            this.context.forceUpdateCartView();
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        {Number(
                                          cartitem.prod.mrp,
                                        ).toLocaleString(
                                          this.context.storeSettings == ""
                                            ? "en-IN"
                                            : this.context.storeSettings
                                                .defaultLocale,
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 1,
                                            style: "currency",
                                            currency:
                                              this.context.storeSettings == ""
                                                ? "INR"
                                                : this.context.storeSettings
                                                    .defaultCurrency,
                                          },
                                        )}
                                      </>
                                    )}
                                  </td>

                                  <td
                                    width="12%"
                                    className="text-center border-0 border-secondary"
                                  >
                                    {this.context.storeSettings
                                      .discountEditableOnCart == true ? (
                                      <>
                                        <Form.Control
                                          type="text"
                                          size="lg"
                                          value={cartitem.prod.discount}
                                          className="text-center"
                                          onChange={(e) => {
                                            cartitem.prod.discount =
                                              e.target.value;
                                            this.context.SetStateOfMyCart(
                                              this.context.getPOSCartByName(
                                                this.context.selectedPOS,
                                              ),
                                            );
                                            this.context.forceUpdateCartView();
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <>{cartitem.prod.discount}%</>
                                    )}
                                  </td>
                                  <td
                                    width="12%"
                                    className=" text-center border-0 border-secondary "
                                  >
                                    <Form.Control
                                      type="number"
                                      id="carttable"
                                      name="qty"
                                      value={
                                        cartitem.qty % 1 == 0
                                          ? cartitem.qty
                                          : Number(cartitem.qty)
                                      }
                                      required
                                      placeholder=""
                                      className="text-center"
                                      autoComplete="new-password"
                                      onChange={(e) => {
                                        this.OnQtyChange(e, cartitem);
                                        // if (e.target.value != cartitem.qty) {
                                        //   cartitem.qty = e.target.value;
                                        //   this.context.SetStateOfMyCart(
                                        //     this.context.getPOSCartByName(
                                        //       this.context.selectedPOS
                                        //     )
                                        //   );
                                        //   this.context.forceUpdateCartView();
                                        //   // this.forceUpdate();
                                        // }
                                      }}
                                      style={{ fontSize: "16px" }}
                                    ></Form.Control>
                                  </td>
                                </>
                              )}
                              <td
                                width="15%"
                                className=" text-end  mx-1 border-0 border-secondary"
                              >
                                <h5>
                                  <b>
                                    {Number(
                                      cartitem.qty *
                                        (cartitem.prod.mrp -
                                          (cartitem.prod.mrp *
                                            cartitem.prod.discount) /
                                            100),
                                    ).toLocaleString(
                                      this.context.storeSettings == ""
                                        ? "en-IN"
                                        : this.context.storeSettings
                                            .defaultLocale,
                                      {
                                        minimumFractionDigits: 1,
                                        maximumFractionDigits: 1,
                                        style: "currency",
                                        currency:
                                          this.context.storeSettings == ""
                                            ? "INR"
                                            : this.context.storeSettings
                                                .defaultCurrency,
                                      },
                                    )}
                                  </b>
                                </h5>
                              </td>

                              <td
                                width="5%"
                                className=" text-center border-0 border-secondary"
                              >
                                <OverlayTrigger
                                  overlay={<Tooltip>Delete!</Tooltip>}
                                  popperConfig={{
                                    modifiers: {
                                      preventOverflow: {
                                        enabled: false,
                                      },
                                    },
                                  }}
                                >
                                  <Button
                                    size="sm"
                                    onClick={(e) => {
                                      this.context.deleteItemOnMyCart(
                                        cartitem.prod.id,
                                      );
                                      this.forceUpdate();
                                      this.context.forceUpdateCartView();
                                    }}
                                    style={{
                                      backgroundColor: "black",
                                      color: "white",
                                      border: 0,
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      // color="white"
                                      class="bi bi-trash"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                      <path
                                        fill-rule="evenodd"
                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                      />
                                    </svg>
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          </div>
                        </>
                      ))}
                  </Table>
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <table
                className="w-100 border-0"
                style={{ tableLayout: "fixed" }}
              >
                <tr
                  className="text-start  border-0"
                  style={{ backgroundColor: "cyan", color: "black" }}
                >
                  <td className="col-md-3">
                    <div className="my-3">
                      <h5>
                        <i class="bi bi-cart-check"></i>
                        &nbsp;<b>CHECKOUT</b>
                      </h5>
                    </div>
                  </td>

                  <td className="col-md-3 text-end ">
                    <Button
                      className="mx-3 border "
                      onClick={this.OnAddCustomItem}
                      style={{ backgroundColor: "#026B54", color: "white" }}
                    >
                      + Custom Item
                    </Button>
                  </td>
                </tr>
              </table>
              <Table
                border
                className="w-100 border m-0 p-0 border-dark text-white"
                responsive="md"
                style={{
                  fontSize: "12pt",
                  tableLayout: "fixed",

                  backgroundColor: this.context.cartBackgroundColor,
                }}
              >
                <thead>
                  <tr className="text-center ">
                    <th width="3%"></th>
                    <th width="47%"></th>
                    <th width="20%">Qty</th>
                    <th width="20%">S.Tot</th>
                    <th width="10%"></th>
                  </tr>
                </thead>
              </Table>
              <div className="w-100 border m-0 p-0 border-dark bg-dark text-white">
                {/* CART Items */}
                <div className="p-1">
                  {this.context
                    .getPOSCartByName(this.context.selectedPOS)
                    .filter((item) => item.prod.id.split("-")[0] != "Custom")
                    .map((item) => item)
                    .reverse()
                    // .toReversed()
                    .map((cartitem, i) => (
                      <>
                        <div className="my-2">
                          <tr className="text-center alignverticalmiddle ">
                            <td>{i + 1}</td>

                            <td className=" text-start" width="47%">
                              {cartitem.prod.imgFileName == undefined ||
                              cartitem.prod.imgFileName == null ||
                              cartitem.prod.imgFileName == "" ? (
                                <></>
                              ) : (
                                <>
                                  <img
                                    src={
                                      this.context.store.storageBlobUrl +
                                      this.context.store
                                        .storageBlobContainerName +
                                      "/images/" +
                                      cartitem.prod.imgFileName +
                                      this.context.store.storageSasToken
                                    }
                                    className="cardprodimg-on-cartview mx-auto rounded-circle"
                                    alt="..."
                                    style={{
                                      cursor: "pointer",
                                      width: ".5cm",
                                    }}
                                  />
                                </>
                              )}
                              {cartitem.prod.name}
                              {cartitem.prod.sku ? (
                                <>
                                  <br />
                                  <span
                                    className="text-warning"
                                    style={{ fontSize: "10px" }}
                                  >
                                    <small>
                                      &nbsp; SKU: {cartitem.prod.sku}
                                    </small>
                                  </span>
                                </>
                              ) : (
                                <></>
                              )}
                              <br></br>
                            </td>
                            <td className=" text-center" width="20%">
                              <Form.Control
                                type="number"
                                id="carttable"
                                name="qty"
                                value={
                                  cartitem.qty % 1 == 0
                                    ? cartitem.qty
                                    : Number(cartitem.qty)
                                }
                                required
                                placeholder=""
                                className="text-center"
                                autoComplete="new-password"
                                onChange={(e) => {
                                  if (e.target.value != cartitem.qty) {
                                    cartitem.qty = e.target.value;
                                    this.context.SetStateOfMyCart(
                                      this.context.getPOSCartByName(
                                        this.context.selectedPOS,
                                      ),
                                    );
                                    this.context.forceUpdateCartView();
                                    // this.forceUpdate();
                                  }
                                }}
                                style={{ fontSize: "16px" }}
                              ></Form.Control>
                            </td>
                            <td className="" width="20%">
                              <b>
                                {Number(
                                  cartitem.qty *
                                    (cartitem.prod.mrp -
                                      (cartitem.prod.mrp *
                                        cartitem.prod.discount) /
                                        100),
                                ).toLocaleString(
                                  this.context.storeSettings == ""
                                    ? "en-IN"
                                    : this.context.storeSettings.defaultLocale,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 1,
                                    style: "currency",
                                    currency:
                                      this.context.storeSettings == ""
                                        ? "INR"
                                        : this.context.storeSettings
                                            .defaultCurrency,
                                  },
                                )}
                              </b>
                            </td>
                            <td className="" width="10%">
                              <OverlayTrigger
                                overlay={<Tooltip>Delete!</Tooltip>}
                                popperConfig={{
                                  modifiers: {
                                    preventOverflow: {
                                      enabled: false,
                                    },
                                  },
                                }}
                              >
                                <Button
                                  // variant="danger"
                                  className="bg-dark text-danger border-0"
                                  onClick={(e) => {
                                    this.context.deleteItemOnMyCart(
                                      cartitem.prod.id,
                                    );
                                    this.forceUpdate();
                                    this.context.forceUpdateCartView();
                                  }}
                                >
                                  <MdDelete size={20} />
                                </Button>
                              </OverlayTrigger>
                            </td>
                          </tr>
                        </div>
                      </>
                    ))}
                </div>

                {/* show custom items */}
                <div>
                  {this.context
                    .getPOSCartByName(this.context.selectedPOS)
                    .filter((item) => item.prod.id.split("-")[0] == "Custom")
                    .length > 0 ? (
                    <>
                      <h4 className="text-danger">
                        <b>
                          <strong>Custom Items</strong>
                        </b>
                      </h4>
                    </>
                  ) : (
                    ""
                  )}

                  {this.context
                    .getPOSCartByName(this.context.selectedPOS)
                    .filter((item) => item.prod.id.split("-")[0] == "Custom")
                    .map((cartitem, i) => (
                      <>
                        <tr className="text-center align-middle text-black">
                          <td>{i + 1}</td>
                          <td width="10%" className=""></td>
                          <td width="30%" className=" text-black text-start">
                            <strong>{cartitem.prod.name}</strong>
                            <br />[
                            {Number(cartitem.prod.mrp).toLocaleString(
                              this.context.storeSettings == ""
                                ? "en-IN"
                                : this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 1,
                                style: "currency",
                                currency:
                                  this.context.storeSettings == ""
                                    ? "INR"
                                    : this.context.storeSettings
                                        .defaultCurrency,
                              },
                            )}
                            ] - {cartitem.prod.discount}% Off
                          </td>
                          <td width="30%" className="">
                            {cartitem.qty}
                          </td>
                          <td width="20%" className="text-black">
                            <strong>
                              {Number(
                                cartitem.qty *
                                  (cartitem.prod.mrp -
                                    (cartitem.prod.mrp *
                                      cartitem.prod.discount) /
                                      100),
                              ).toLocaleString(
                                this.context.storeSettings == ""
                                  ? "en-IN"
                                  : this.context.storeSettings.defaultLocale,
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 1,
                                  style: "currency",
                                  currency:
                                    this.context.storeSettings == ""
                                      ? "INR"
                                      : this.context.storeSettings
                                          .defaultCurrency,
                                },
                              )}
                            </strong>
                          </td>
                          <td width="10%" className="">
                            <OverlayTrigger
                              overlay={<Tooltip>Delete!</Tooltip>}
                              popperConfig={{
                                modifiers: {
                                  preventOverflow: {
                                    enabled: false,
                                  },
                                },
                              }}
                            >
                              <Button
                                className="bg-white border-0"
                                onClick={(e) => {
                                  this.context.deleteItemOnMyCart(
                                    cartitem.prod.id,
                                  );
                                  this.forceUpdate();
                                  this.context.forceUpdateCartView();
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  color="red"
                                  fill="currentColor"
                                  class="bi bi-trash"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                  <path
                                    fill-rule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                  />
                                </svg>
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      </>
                    ))}
                </div>
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </>
        )}
      </>
    );
  }
}

export class AddCustomItem extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productName: "",
      price: "0",
      discount: "0",
      qty: "1",
      sellingPrice: "",
      prodsSelect: [],
      prodSelectRef: "",
      productName: [],
    };
  }
  LoadProducts = () => {
    {
      var p = [];

      this.context.prodsAll
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map(
          (r) =>
            p.push({
              value: r.name,
              label: r.name,
            }),
          //p.push(r.name)
        );
      this.setState({ prodsSelect: p });
    }
  };

  OnProductSelectChange = (e) => {
    if (e.value) {
      this.setState({ productName: e.value });
    } else {
      if (e.target.defaultValue == "") return;
      this.state.prodsSelect.push({
        value: e.target.defaultValue,
        label: e.target.defaultValue,
      });
      this.setState({ prodsSelect: this.state.prodsSelect });
      this.setState({ productName: e.target.defaultValue });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    //validate for minus values not to allow
    switch (name.trim()) {
      case "productName":
        this.setState({ productName: value });
        break;
      case "price":
        this.setState({ price: value });
        break;
      case "discount":
        this.setState({ discount: value });
        break;
      case "qty":
        if (Number(value) || value == "" || value == ".") {
          this.setState({ qty: value });
        }
        break;
    }
  };

  getWeight = () => {
    var res = axios
      .get(
        process.env.REACT_APP_API +
          "Consumers/GetWeightByIPAddress/" +
          this.props.myClientIpAddress,
      )
      .then((response) => {
        if (response.status == 200) {
          if (response.data != null && response.data != "")
            this.setState({ qty: Number(response.data.scaleValue).toFixed(2) });
        }
      });
  };
  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }

    this.context.addCustomItemToMyCart({
      prod: {
        id: "Custom-" + this.context.GetNewGuid(),
        name: this.state.productName,
        mrp: this.state.price,
        discount: this.state.discount,
      },
      qty: this.state.qty,
    });
    this.props.onHide();
  };
  componentDidMount = () => {
    this.LoadProducts();

    document.addEventListener("keyup", (e) => {
      if (e.keyCode === 27) {
        this.CloseModal();
      }
    });

    if (this.state.prodSelectRef) {
      this.state.prodSelectRef.focus();
    }
  };

  CloseModal = () => {
    this.props.onHide();
  };

  render() {
    const filterConfig = { matchFrom: "start" };
    const colourStyles = {
      menuPortal: (base) => ({
        ...base,
        fontSize: "14px",
      }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        // const color = chroma(data.color);
        console.log({ data, isDisabled, isFocused, isSelected });
        return {
          ...styles,
          backgroundColor: isFocused ? "green" : null,
          color: isFocused ? "white" : "#333333",
        };
      },
    };
    return (
      <>
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          show={true}
          // dialogClassName="payByCash"
        >
          <Form
          // onSubmit={this.handleSubmit}
          >
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                Add Custom Item
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row className="py-1">
                <Col className="col-md-12">
                  <h2>Product Name:</h2>

                  <Select
                    id="prodSelect"
                    menuPosition="fixed"
                    components={
                      this.state.prodsSelect.length > 1000 ? { MenuList } : ""
                    }
                    styles={colourStyles}
                    ref={(ref) => {
                      this.state.prodSelectRef = ref;
                    }}
                    value={{
                      value: this.state.productName,
                      label: this.state.productName,
                    }}
                    onChange={(e) => this.OnProductSelectChange(e)}
                    onBlur={(e) => this.OnProductSelectChange(e)}
                    options={this.state.prodsSelect}
                    // captureMenuScroll={false}
                    onKeyDown={(e) => {
                      //ENTER KEY
                      if (e.keyCode == 13) {
                        var ctrl = document.getElementById("price");
                        if (ctrl) {
                          ctrl.focus();
                          ctrl.select();
                        }
                      }
                    }}
                  ></Select>
                </Col>
              </Row>
              <Row className="py-1">
                <Col className="col-md-4">
                  <h2>Price:</h2>
                </Col>
                <Col className="col-md-8">
                  <Form.Control
                    type="number"
                    id="price"
                    size="lg"
                    name="price"
                    value={this.state.price}
                    required
                    placeholder=""
                    autoComplete="new-password"
                    onChange={(e) => this.handleInputChange(e)}
                    style={{ fontSize: "26px" }}
                    onKeyDown={(e) => {
                      //ENTER KEY
                      if (e.keyCode == 13) {
                        var ctrl = document.getElementById("discount");
                        if (ctrl) {
                          ctrl.focus();
                          ctrl.select();
                        }
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row className="py-1">
                <Col className="col-md-4">
                  <h2>Discount(%):</h2>
                </Col>
                <Col className="col-md-8">
                  <Form.Control
                    type="number"
                    size="lg"
                    id="discount"
                    name="discount"
                    value={this.state.discount}
                    required
                    placeholder=""
                    autoComplete="new-password"
                    onChange={(e) => this.handleInputChange(e)}
                    style={{ fontSize: "26px" }}
                    onKeyDown={(e) => {
                      //ENTER KEY
                      if (e.keyCode == 13) {
                        var ctrl = document.getElementById("qty");
                        if (ctrl) {
                          ctrl.focus();
                          ctrl.select();
                        }
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row className="py-1">
                <Col className="col-md-4">
                  <h2>Qty:</h2>
                </Col>

                <Col className="col-md-8">
                  <Stack direction="horizontal">
                    <Form.Control
                      type="text"
                      size="lg"
                      id="qty"
                      name="qty"
                      value={this.state.qty}
                      required
                      placeholder=""
                      autoComplete="new-password"
                      onChange={(e) => this.handleInputChange(e)}
                      style={{ fontSize: "26px" }}
                      onKeyDown={(e) => {
                        //ENTER KEY
                        if (e.keyCode == 13) {
                          this.handleSubmit(e);
                        }
                      }}
                    />
                  </Stack>
                </Col>
              </Row>
              <Row className="py-1">
                <Col className="col-md-4">
                  <h2>Selling Price:</h2>
                </Col>
                <Col className="col-md-8">
                  <h2>
                    {Math.round(
                      this.state.price * this.state.qty -
                        (this.state.price *
                          this.state.qty *
                          this.state.discount) /
                          100,
                      0,
                    )}
                  </h2>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button
                  variant="primary"
                  size="lg"
                  // type="submit"
                  disabled={
                    !(
                      Number(this.state.qty) > 0 &&
                      Number(
                        this.state.price > 0 && this.state.productName != "",
                      )
                    )
                  }
                  onClick={this.handleSubmit}
                >
                  {/* <Button variant="primary" size="lg" onClick={this.handleSubmit}> */}
                  Add
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }
}

export class OrderType extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      orderTypeOrderDelivered: true,
      orderTypeTakeAway: false,
      orderTypeHomeDelivery: false,
    };
  }

  handleChangeOrderType = (event) => {
    this.setState({
      orderTypeOrderDelivered: false,
      orderTypeTakeAway: false,
      orderTypeHomeDelivery: false,
    });

    switch (event.target.id) {
      case "InStore":
        this.setState({ orderTypeOrderDelivered: true });
        this.context.SetBaseMode(this.context.selectedPOS);
        break;
      case "TakeAway":
        this.setState({ orderTypeTakeAway: true });
        this.context.SetTakeAwayMode(this.context.selectedPOS);
        break;
      case "HomeDelivery":
        this.setState({ orderTypeHomeDelivery: true });
        this.context.SetHomeDeliveryMode(this.context.selectedPOS);
        break;
    }
    this.props.handleChangeOrderType(event.target.id);
  };

  componentDidMount() {
    const selected = this.context.GetSelectedPosOrderType(
      this.context.selectedPOS,
    );
    this.setState({
      orderTypeOrderDelivered: selected === "InStore",
      orderTypeTakeAway: selected === "TakeAway",
      orderTypeHomeDelivery: selected === "HomeDelivery",
    });
  }

  render() {
    return (
      <div className="text-center p-1">
        <ButtonGroup className="w-100">
          <ToggleButton
            id="InStore"
            type="radio"
            variant={
              this.state.orderTypeOrderDelivered
                ? "primary"
                : "outline-secondary"
            }
            name="deliverytype"
            value="InStore"
            checked={this.state.orderTypeOrderDelivered}
            onChange={this.handleChangeOrderType}
            className="fw-bold"
          >
            {this.context.store.businessTypeId === 3
              ? "KOT / DineIn"
              : "InStore"}
          </ToggleButton>

          <ToggleButton
            id="TakeAway"
            type="radio"
            variant={
              this.state.orderTypeTakeAway ? "primary" : "outline-secondary"
            }
            name="deliverytype"
            value="TakeAway"
            checked={this.state.orderTypeTakeAway}
            onChange={this.handleChangeOrderType}
            className="fw-bold"
            disabled={this.context.storeSettings.hideTakeAwayOptionOnPos}
          >
            Take-Away
          </ToggleButton>

          <ToggleButton
            id="HomeDelivery"
            type="radio"
            variant={
              this.state.orderTypeHomeDelivery ? "primary" : "outline-secondary"
            }
            name="deliverytype"
            value="HomeDelivery"
            checked={this.state.orderTypeHomeDelivery}
            onChange={this.handleChangeOrderType}
            className="fw-bold"
            disabled={this.context.storeSettings.hideHomeDeliveryOptionOnPos}
          >
            Delivery
          </ToggleButton>
        </ButtonGroup>
      </div>
    );
  }
}

class CustomerDetail extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      customerDetail: {
        firstName: "",
        emailId: "",
        mobileNo: "",
        address: "",
      },
      tmobileNo: "",
    };
  }
  handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name.trim()) {
      case "firstName":
        this.state.customerDetail.firstName = value;
        break;
      case "tmobileNo":
        this.setState({ tmobileNo: value });
        return;
      case "mobileNo":
        if (isNaN(Number(value)) == false)
          this.state.customerDetail.mobileNo = value;
        break;
      case "emailId":
        this.state.customerDetail.emailId = value;
        break;
      case "address":
        this.state.customerDetail.address = value;
        break;
    }
    this.setState({ customerDetail: this.state.customerDetail });
  };

  GetCustomerAccountByMobileNo = (e) => {
    if (
      this.state.tmobileNo == "" ||
      (this.state.tmobileNo != "" && this.state.tmobileNo.length != 10)
    ) {
      // alert("Invalid MobileNo. Enter 10 digit valid number!");
      Swal.fire({
        title: "Invalid MobileNo!",
        text: "Enter 10 digit valid Mobile number!",
        confirmButtonText: "ok",
        //timer: 1500,
      }).then((result) => {});
      return;
    }
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetCustomerAccountByMobileNo/" +
        this.context.storeId +
        "/" +
        this.state.tmobileNo,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          alert("Mobile Number Not Found!");
        } else {
          this.setState({ showCustomerDetails: true });
          this.setState({ customerDetail: data }, () => {
            this.setState({ reload: true }, () => {
              this.setState({ reload: false });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  render() {
    return (
      <>
        <Row className="w-100 bg-light rounded-3 border-0 p-1 m-0">
          <Col md={8} className="border ">
            <h6>Customer Name & Number</h6>
          </Col>
          <Col md={4} className=" border-0 text-start align-middle">
            <Button
              variant="success"
              className="w-100 "
              // size="lg"
              onClick={(e) => this.GetCustomerAccountByMobileNo(e)}
            >
              Get / Add
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

class AddFromSaleOrderModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      salesOrders: [],
      selectedOrderId: null,
      loadingDetails: false,
      addedToCart: false,

      // new for search/filter
      searchTerm: "",
      showOnlyStatuses: [1, 2], // only show status 1 or 2
    };
  }

  componentDidMount() {
    this.loadSalesOrders();
  }

  loadSalesOrders = async () => {
    try {
      this.setState({ loading: true });
      const storeId = this.context.storeId;
      const resp = await axios.get(
        `${process.env.REACT_APP_API}SalesOrder/GetSalesOrders/${storeId}`,
      );
      // keep original list; filtering will be done client-side
      this.setState({ salesOrders: resp.data || [] });
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Unable to load sales orders", "error");
    } finally {
      this.setState({ loading: false });
    }
  };

  // Fetch full order (with items)
  loadOrderDetails = async (orderId) => {
    try {
      this.setState({ loadingDetails: true });
      const resp = await axios.get(
        `${process.env.REACT_APP_API}SalesOrder/GetSalesOrderById/${orderId}`,
      );
      return resp.data;
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Unable to load order details", "error");
      return null;
    } finally {
      this.setState({ loadingDetails: false });
    }
  };

  // Map SalesOrderItem -> cart item and add to cart
  addOrderItemsToCart = async (orderId) => {
    const order = await this.loadOrderDetails(orderId);
    if (!order) return;

    const items = order.salesOrderItems || order.SalesOrderItems || [];

    const cartName = this.context.selectedPOS;
    const currentCart = this.context.getPOSCartByName(cartName) || [];

    for (const it of items) {
      // find product in master list
      const prod = this.context.prodsAll
        ? this.context.prodsAll.find(
            (p) => String(p.id) === String(it.productId),
          )
        : null;

      // compute remaining balances
      const remainingPieces =
        (it.piecesOrdered ?? it.PiecesOrdered ?? 0) -
        (it.piecesDelivered ?? it.PiecesDelivered ?? 0);

      const remainingQty =
        (it.qtyOrdered ?? it.QtyOrdered ?? 0) -
        (it.qtyDelivered ?? it.QtyDelivered ?? 0);

      if (remainingPieces <= 0 && remainingQty <= 0) {
        continue; // nothing left to add
      }

      const cartItem = {
        prod: prod
          ? { ...prod }
          : {
              id: it.productId || "Custom-" + this.context.GetNewGuid(),
              name: it.itemName || it.ItemName || "SaleOrder Item",
              mrp: it.mrp ? it.mrp : 0,
              discount: 0,
            },
        qty: remainingQty > 0 ? remainingQty : 0,
        pieceCount: remainingPieces > 0 ? remainingPieces : 0,
        salesOrderId: order.id,
      };

      currentCart.push(cartItem);
    }

    this.context.SetStateOfMyCart(currentCart);
    this.context.SetForceUpdatePosCart(true);

    Swal.fire("Done", "Remaining items added to cart", "success");
    if (this.props.onHide) this.props.onHide();
  };

  // --- Search handlers ---
  onSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  clearSearch = () => {
    this.setState({ searchTerm: "" });
  };

  // compute filtered list (status filter + orderId search)
  getFilteredOrders = () => {
    const { salesOrders, searchTerm, showOnlyStatuses } = this.state;
    const term = (searchTerm || "").trim().toLowerCase();

    return (salesOrders || []).filter((so) => {
      // ensure status in allowed list (some responses may use StatusId or statusId)
      const status =
        so.statusId ?? so.StatusId ?? so.status ?? so.Status ?? null;
      if (showOnlyStatuses && showOnlyStatuses.length > 0) {
        if (!showOnlyStatuses.includes(Number(status))) return false;
      }

      // if no search term, include it
      if (!term) return true;

      // match orderId or OrderId
      const orderIdVal = String(
        so.orderId ?? so.OrderId ?? so.OrderNo ?? "",
      ).toLowerCase();

      // also check customer name optionally
      const customerVal = String(
        so.customerName ?? so.CustomerName ?? "",
      ).toLowerCase();

      return orderIdVal.includes(term) || customerVal.includes(term);
    });
  };

  render() {
    const filtered = this.getFilteredOrders();
    const { loading } = this.state;

    return (
      <Modal
        show={true}
        onHide={this.props.onHide}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Sale Order</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Search bar */}
          <div className="mb-3 d-flex gap-2 align-items-center">
            <InputGroup>
              <FormControl
                placeholder="Search by OrderId or Customer name..."
                value={this.state.searchTerm}
                onChange={this.onSearchChange}
                onKeyDown={(e) => {
                  // optional: Enter to trigger (we already filter live)
                  if (e.key === "Escape") this.clearSearch();
                }}
              />
              <Button variant="outline-secondary" onClick={this.clearSearch}>
                Clear
              </Button>
            </InputGroup>

            <div style={{ marginLeft: "auto" }}>
              <Badge bg="secondary">Showing {filtered.length}</Badge>
            </div>
          </div>

          {loading ? (
            <div>Loading sales orders...</div>
          ) : filtered.length === 0 ? (
            <div>No matching sales orders (status 1 or 2 only).</div>
          ) : (
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>OrderId</th>
                  <th>Date</th>
                  <th>Customer</th>
                  <th>Qty</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((so, idx) => (
                  <tr key={so.id || idx}>
                    <td>{idx + 1}</td>
                    <td>{so.orderId ?? so.OrderId ?? so.OrderNo}</td>
                    <td>
                      {so.created ? new Date(so.created).toLocaleString() : ""}
                    </td>
                    <td>{so.customerName ?? so.CustomerName}</td>
                    <td>{so.totQty ?? so.TotQty ?? so.totalQty ?? ""}</td>
                    <td>{so.totPrice ?? so.TotPrice ?? so.total ?? ""}</td>
                    <td>
                      <Button
                        size="sm"
                        onClick={() => this.addOrderItemsToCart(so.id || so.Id)}
                      >
                        Add Items
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
